/* eslint-disable */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import axios from "axios";
import QRCode from 'qrcode';
import moment from 'moment';
import { convertLocalImageToBase64 } from '../../utils/imageUtils';

function formatearFechaLugar(fecha) {
    let dia, mes, año;
    
    // Verificar si la fecha está en formato YYYY-MM-DD (input date)
    if (fecha.includes('-')) {
        [año, mes, dia] = fecha.split('-');
    } else {
        // Formato anterior DD/MM/YYYY
        [dia, mes, año] = fecha.split('/');
    }
    
    const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Convertir el mes de número a nombre (restamos 1 porque los meses en JS van de 0-11)
    const nombreMes = meses[parseInt(mes) - 1];

    // Eliminar ceros a la izquierda del día
    const diaFormateado = parseInt(dia).toString();

    return `El Guabo, ${diaFormateado} de ${nombreMes} de ${año}`;
}

async function generateQRCode(data) {
    try {
        const qrDataUrl = await QRCode.toDataURL(data);
        return qrDataUrl;
    } catch (error) {
        console.error('Error generando QR:', error);
        throw error;
    }
}

function numeroATexto(numero) {
    const unidades = ['CERO', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE', 'DIEZ',
        'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE', 'VEINTE',
        'VEINTIUNO', 'VEINTIDÓS', 'VEINTITRÉS', 'VEINTICUATRO', 'VEINTICINCO', 'VEINTISÉIS', 'VEINTISIETE', 'VEINTIOCHO', 'VEINTINUEVE', 'TREINTA'];

    if (numero >= 0 && numero <= 30) {
        return unidades[numero];
    }
    return numero.toString();
}


function formatearFechaCompleta(fecha) {
    const fechaMoment = moment(fecha, 'YYYY-MM-DD');
    
    return fechaMoment.format('DD/MM/YYYY');
}

export const generatePdfCertificadoV2 = async (certificadoData, textAletraFechaInicial, textAletraFechaFinal, startDate, endDate, CorreoDoctor, CelularDoctor) => {
    try {
        const imageUrl = await convertLocalImageToBase64('/img/certificados/padre.png');
        const footerImageUrl = await convertLocalImageToBase64('/img/certificados/footer-receta.png');

        // Generar datos para el QR
        const fechaHoraActual = new Date().toLocaleString('es-EC', {
            timeZone: 'America/Guayaquil',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });

        const qrData = `
            FECHA: ${fechaHoraActual}\n
            PACIENTE: ${certificadoData.paciente.nombres}\n
            DOCTOR: ${certificadoData.paciente.doctor}\n
            ESPECIALIDAD: ${certificadoData.paciente.especialidad}
            `

        const qrCodeUrl = await generateQRCode(qrData);

        // Calcular días de diferencia usando moment
        const fecha1 = moment(startDate, 'YYYY-MM-DD');
        const fecha2 = moment(endDate, 'YYYY-MM-DD');
        const diferencia = fecha2.diff(fecha1, 'days') + 1;
        const diasEnTexto = numeroATexto(diferencia);

        const fechaInicialFormateada = formatearFechaCompleta(startDate);
        const fechaFinalFormateada = formatearFechaCompleta(endDate);

        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [30, 20, 30, 30],
            background: function (currentPage, pageSize) {
                return {
                    image: imageUrl,
                    width: 400,
                    absolutePosition: { x: (pageSize.width - 400) / 2, y: (pageSize.height - 400) / 2 },
                    opacity: 0.07
                };
            },
            content: [
                {
                    columns: [
                        { image: imageUrl, width: 70, margin: [0, 0, 10, 0] },
                        {
                            stack: [
                                { text: 'CENTRO MÉDICO DE ESPECIALIDADES "P. EMILIO CATALÁN"', style: 'header' },
                                {
                                    text: [
                                        { text: 'Dirección: ', bold: true },
                                        { text: 'Pasaje e/ Bolivar y Sucre. (Junto a la Botica Comunitaria)' }
                                    ],
                                    style: 'subheader1'
                                },
                                { text: 'El Guabo - El Oro - Ecuador', style: 'subheader1' },
                                { text: 'Correo: ' + CorreoDoctor, fontSize: 10, alignment: 'center', margin: [0, 0, 0, 3] },
                                { text: 'Móvil: ' + CelularDoctor, fontSize: 10, alignment: 'center',  margin: [0, 0, 0, 3] }
                            ],
                            width: 'auto',
                            alignment: 'center'
                        },
                    ]
                },
                generateLineaEncabezado(),
                {
                    text: 'CERTIFICADO MÉDICO',
                    style: 'header2',
                    margin: [0, 15, 0, 15]
                },
                {
                    text: [
                        { text: formatearFechaLugar(certificadoData.fechaEmision) }
                    ],
                    alignment: 'right',
                    fontSize: 10,
                    margin: [0, 0, 0, 15]
                },
                {
                    text: [
                        `Certifico que el/la paciente: `,
                        { text: certificadoData.paciente.nombres, bold: true },
                        ', con cédula de identidad ',
                        { text: certificadoData.paciente.cedula, bold: true },
                        ', con ',
                        { text: certificadoData.paciente.edad, bold: true },
                        ', acude a este consultorio médico hemodinámicamente ',
                        { text: 'ESTABLE.', bold: true },
                    ],
                    fontSize: 10,
                    margin: [0, 0, 0, 10],  // Espaciado inferior
                    alignment: 'justify',   // Justificar el texto
                    lineHeight: 1.5         // Espaciado entre líneas
                },

                // Información de la empresa
                {
                    text: [
                        { text: 'Tipo de Contingencia: ', bold: true },
                        certificadoData.empresa.tipoContingencia,
                        '\n',
                        { text: 'Empresa: ', bold: true },
                        certificadoData.empresa.empresa,
                        '\n',
                        { text: 'Cargo: ', bold: true },
                        certificadoData.empresa.cargo,
                        '\n',
                        { text: 'Dirección: ', bold: true },
                        certificadoData.empresa.direccion,
                        '\n',
                        { text: 'Historia Clinica: ', bold: true },
                        certificadoData.paciente.cedula,
                        '\n',
                        { text: 'Celular: ', bold: true },
                        certificadoData.empresa.celular,
                        '\n',
                        { text: 'Email: ', bold: true },
                        certificadoData.empresa.email || 'No tiene'
                    ],
                    fontSize: 10,
                    margin: [0, 0, 0, 10],
                    lineHeight: 1.5
                },

                // Tabla de Antecedentes
                {
                    table: {
                        widths: ['*', '*'],
                        headerRows: 1,
                        body: [
                            [
                                { 
                                    text: 'ANTECEDENTES PATOLÓGICOS PERSONALES',
                                    fillColor: '#f2f2f2',
                                    bold: true,
                                    fontSize: 10,
                                    alignment: 'center'
                                },
                                { 
                                    text: 'ANTECEDENTES PATOLÓGICOS QUIRÚRGICOS',
                                    fillColor: '#f2f2f2',
                                    bold: true,
                                    fontSize: 10,
                                    alignment: 'center'
                                }
                            ],
                            [
                                {
                                    text: certificadoData.empresa.antecedentes_personales || 'NINGUNO',
                                    fontSize: 10,
                                    alignment: 'justify'
                                },
                                {
                                    text: certificadoData.empresa.antecedentes_quirurgicos || 'NINGUNO',
                                    fontSize: 10,
                                    alignment: 'justify'
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: function(i, node) {
                            return 1;
                        },
                        vLineWidth: function(i, node) {
                            return 1;
                        },
                        hLineColor: function(i, node) {
                            return '#aaaaaa';
                        },
                        vLineColor: function(i, node) {
                            return '#aaaaaa';
                        },
                        paddingLeft: function(i, node) { return 10; },
                        paddingRight: function(i, node) { return 10; },
                        paddingTop: function(i, node) { return 10; },
                        paddingBottom: function(i, node) { return 10; }
                    },
                    margin: [0, 0, 0, 20]
                },

                { text: 'DIAGNÓSTICO: ', bold: true, fontSize: 11, margin: [0, 0, 0, 10] },
                {
                    ul: certificadoData.diagnosticos.map(diagnostico => ({
                        text: `${diagnostico.Codigo} - ${diagnostico.Descriptor}`,
                        fontSize: 10,
                        lineHeight: 1.5
                    })),
                    margin: [0, 0, 0, 30]
                },
                {
                    text: [
                        'Por lo cual se le otorga reposo médico absoluto por ',
                        { text: `${diferencia} (${diasEnTexto})`, bold: true },
                        ' días, desde el ',
                        { text: fechaInicialFormateada, bold: true },
                        ' (' + textAletraFechaInicial + ') hasta el ',
                        { text: fechaFinalFormateada, bold: true },
                        ' (' + textAletraFechaFinal + ').'
                    ],
                    fontSize: 10,
                    lineHeight: 1.5,
                    alignment: 'justify',
                    margin: [0, 0, 0, 20]
                },
                {
                    text: 'Atentamente,',
                    alignment: 'left',
                    fontSize: 10,
                    margin: [0, 20, 0, 30]
                },
                {
                    text: '----------------------------------------------------',
                    alignment: 'center',
                    fontSize: 11,
                    margin: [0, 30, 0, 5]
                },
                {
                    text: certificadoData.paciente.doctor,
                    alignment: 'center',
                    bold: true,
                    fontSize: 10,
                    margin: [0, 0, 0, 5]
                },
                {
                    text: 'C.i.: ' + certificadoData.doctor_dni,
                    alignment: 'center',
                    bold: true,
                    fontSize: 10,
                    margin: [0, 0, 0, 5]
                },
                {
                    text: certificadoData.paciente.especialidad,
                    alignment: 'center',
                    bold: true,
                    italics: true,
                    fontSize: 10,
                    margin: [0, 0, 0, 0]
                },
                {
                    absolutePosition: { x: 480, y: 660 },
                    stack: [
                        {
                            image: qrCodeUrl,
                            width: 90
                        },
                        {
                            text: 'Código de Verificación',
                            fontSize: 8,
                            alignment: 'center',
                            margin: [0, 5, 0, 0]
                        }
                    ]
                }
            ],
            footer: function (currentPage, pageCount) {
                return {
                    columns: [
                        { image: footerImageUrl, width: 635, alignment: 'center', margin: [0, -65, 0, 0] }
                    ]
                };
            },
            styles: {
                header: { fontSize: 14, color: '#01365e', bold: true, alignment: 'center', margin: [0, 0, 0, 3] },
                header2: { fontSize: 13, color: '#01365e', bold: true, characterSpacing: 5, alignment: 'center', margin: [0, 0, 0, 5] },
                subheader1: { fontSize: 11, alignment: 'center', margin: [0, 0, 0, 3] }
            }
        };

        pdfMake.createPdf(docDefinition).open();
    } catch (error) {
        console.error('Error al generar el PDF:', error);
    }
};

// Función para descargar y convertir la imagen en Base64
async function downloadImage(url) {
    try {
        const response = await axios.get(url, { responseType: 'blob' });
        const blob = response.data;

        const imageUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

        return imageUrl;
    } catch (error) {
        console.error('Error al descargar la imagen:', error);
        throw error;
    }
}


// Función para generar una línea divisoria
function generateLineaEncabezado() {
    return {
        margin: [0, 10, 0, 0],
        table: {
            widths: ['100%'],
            body: [
                [
                    {
                        text: '',
                        fillColor: '#01365e',
                        border: [false, false, false, false],
                        height: 1
                    }
                ]
            ]
        },
        layout: 'noBorders'
    };
}